import React from 'react';
import { useSelector } from 'react-redux';
import { PayoutMethodsManager, IonicButton } from 'ionic-ui';
import { IonIcon } from '@ionic/react';
import { keyOutline } from 'ionicons/icons';
import { RootState } from '../../../../../store/store';
import { baseURL } from '../../../../../data/config';
import { useDialog } from '../../../../../context/Dialog';
import SetWalletPinDialog from '../../../../../components/Dashboard/home/wallet/dialogs/walletOpsDialogs/SetWalletPinDialog';

export default function PayoutsPage() {
  const { signedAccessToken } = useSelector(
    (state: RootState) => state.userSession
  );
  const { openDialog } = useDialog();

  return (
    <div className="space-y-4 pb-8">
      <header>
        <h2 className="text-lg font-semibold text-text-dark-high dark:text-text-light-high">
          Payouts
        </h2>
        <p className="text-sm text-text-dark-medium dark:text-text-light-medium">
          Manage where your earnings settle.
        </p>
      </header>

      <div className="p-4 rounded-lg border border-border bg-background dark:bg-background-accent flex items-center justify-between gap-4">
        <div>
          <h3 className="text-base font-semibold high-emphasis-text">
            Wallet PIN
          </h3>
          <p className="text-xs medium-emphasis-text">
            Your 6-digit PIN authorizes wallet transfers and withdrawals.
          </p>
        </div>
        <IonicButton
          variant="outline"
          type="button"
          onClick={() =>
            openDialog(<SetWalletPinDialog />, {
              allowBackgroundDismiss: false,
            })
          }
        >
          <IonIcon icon={keyOutline} className="mr-1.5 size-4" />
          Set / change PIN
        </IonicButton>
      </div>

      <PayoutMethodsManager baseURL={baseURL} accessToken={signedAccessToken} />
    </div>
  );
}
